import React from 'react';
import InstructionsInfoItem from './InstructionsInfoItem';
import type { InstructionsInfoItem as InfoItem } from '@app-types/instructions';
import './InstructionsInfoList.less';

export type InstructionsInfoListState = 'loading' | 'error' | 'empty' | 'ready';

export interface InstructionsInfoListProps {
  items: InfoItem[];
  state?: InstructionsInfoListState;
  isOpeningReport?: boolean;
  onOpenReport?: (item: InfoItem) => Promise<string>;
  nodeId?: string;
}

const STATE_MESSAGE: Record<Exclude<InstructionsInfoListState, 'ready'>, string> = {
  loading: '適時開示情報を読み込んでいます。',
  empty: '適時開示情報はありません。',
  error: '適時開示情報の取得に失敗しました。',
};

/**
 * List container for the disclosure rows.
 * Each `InstructionsInfoItem` renders its own bottom border; the wrapper
 * adds an outer 1px frame and removes the last row's redundant bottom
 * border to avoid a double line.
 * Figma: desktop 3176:9091 (628 x 569), mobile 3177:10457 (343 x 688).
 */
const InstructionsInfoList: React.FC<InstructionsInfoListProps> = ({
  items,
  state = items.length > 0 ? 'ready' : 'empty',
  isOpeningReport = false,
  onOpenReport,
  nodeId,
}) => (
  <div
    className="instructions-info-list"
    data-node-id={nodeId}
    role={state === 'ready' ? 'list' : undefined}
    aria-busy={state === 'loading' || undefined}
  >
    {state === 'ready' ? items.map((item) => (
      <div role="listitem" key={item.key}>
        <InstructionsInfoItem
          data={item}
          isOpeningReport={isOpeningReport}
          onOpenReport={onOpenReport}
        />
      </div>
    )) : (
      <p
        className="instructions-info-list__state"
        role={state === 'error' ? 'alert' : 'status'}
      >
        {STATE_MESSAGE[state]}
      </p>
    )}
  </div>
);

export default InstructionsInfoList;
